import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

const customConfig = defineConfig({
  globalCss: {
    '*::selection': {
      bg: 'blue.600',
      color: 'white',
    },
    // AppShell owns the page's primary scroll containers; never let the
    // body itself scroll. Without this, pages whose body has a hardcoded
    // min-width (e.g. AssumptionSets/Diagnosis 1850px) would force
    // horizontal page scroll, which then shifts viewport coordinates and
    // breaks Playwright `boundingBox` assertions plus pushes
    // position:fixed dialog close buttons "outside of the viewport".
    body: {
      overflow: 'hidden',
    },
  },
})

export const system = createSystem(defaultConfig, customConfig)
